<!-- Projects Widget -->
<div class="rounded-[20px] bg-white widget-card flex flex-col items-start min-w-0 h-full overflow-clip">
    <!-- Header -->
    <div class="flex items-center shrink-0 w-full">
        <div class="flex items-center gap-[8px]">
            <span class="projects-title widget-title text-black">Projects</span>
            <i class="pi pi-info-circle text-[16px] w-4 h-4 text-[#787B83]"
                pTooltip="Total count of projects categorized by status" tooltipPosition="top"></i>
        </div>
    </div>

    <!-- Chart -->
    @if (loading()) {
    <div class="w-full h-[15.625rem] shrink-0 flex items-end justify-around gap-3 px-4 pb-6">
        <p-skeleton *ngFor="let h of [4.375, 6.875, 3.75, 8.75, 5.625, 3.125, 7.5]" width="2rem" [height]="h + 'rem'"
            borderRadius="0.75rem"></p-skeleton>
    </div>
    } @else {
    <div echarts [options]="chartOptions()" (chartClick)="onChartClick($event)"
        class="w-full h-[15.625rem] shrink-0 overflow-hidden"></div>
    }
</div>